<template>
    <div id="app">
        <el-header>ITEM工具
            <span style="float: right; cursor: pointer;" @click="logout" v-if="aside">logout</span>
        </el-header>
        <el-container class="router-page">
            <zf-aside v-if="aside"></zf-aside>
            <el-main>
                <zf-loading v-show="loading"></zf-loading>
                <router-view v-if="show" :key="$route.fullPath"/>
            </el-main>
        </el-container>
    </div>
</template>

<script>
  import Aside from "@/components/common/aside";
  import Loading from "@/components/common/loading";
  import {logout} from "@/services/api";
  import store from "@/store";

  export default {
    components: {
      'zf-aside': Aside,
      'zf-loading': Loading,
    },
    computed: {
      show() {
        return this.$store.state.show;
      },
      loading() {
        return this.$store.state.loading;
      },
      aside() {
        if (this.$route.path === '/login') return false;
        return true;
      }
    },
    methods: {
      logout() {
        this.$confirm('确定登出吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          logout({});
          store.commit('SET_REGION', []);
          store.commit('SET_TOUSHOU', []);
          store.commit('SET_LANGUAGE', []);
          store.commit('SET_DOMAIN', []);
          store.commit('SET_AUTHORITY', []);
          store.commit('SET_STATUS_LIST', []);
          this.$router.push('/login');
        });
      }
    },
  }
</script>

<style lang="scss">
    * {
        box-sizing: border-box;
    }

    #app {
        min-width: 1150px;
        font-family: '微软雅黑', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    body,
    dd,
    dl,
    dt,
    fieldset,
    form,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    html,
    img,
    legend,
    li,
    ol,
    p,
    ul,
    input,
    select,
    textarea {
        font-family: '微软雅黑', sans-serif;
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
    }

    button,
    fieldset,
    img,
    input {
        border: none;
        padding: 0;
        margin: 0;
        outline-style: none;
    }

    ul,
    li {
        background-color: #ffffff;
    }

    ol,
    ul {
        list-style: none;
    }

    input {
        padding-top: 0;
        padding-bottom: 0;
    }

    input,
    select {
        vertical-align: middle;
    }

    textarea {
        resize: none;
    }

    /*防止拖动*/
    img {
        border: 0;
        vertical-align: middle;
    }

    /*  去掉图片低测默认的3像素空白缝隙*/
    table {
        border-collapse: collapse;
    }

    i {
        font-style: normal;
    }

    a {
        color: #666;
        text-decoration: none;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
        margin: 0;
    }

    .router-page {
        height: calc(100vh - 60px);
        border: 1px solid #eee;
    }

    .el-header {
        padding-left: 20px;
        background-color: #434343;
        color: #fff;
        line-height: 60px;
        text-align: left;
        font-size: 20px;
    }

    .el-aside {
        border-right: solid 1px #e6e6e6;
        color: #333;

        .el-menu {
            border: none;
        }

        .el-submenu .el-menu-item {
            height: 40px;
            line-height: 40px;
        }
    }

    .el-main {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 5px 20px !important;
    }

    body .el-table th.gutter {
        display: table-cell !important;
    }

    body .el-table colgroup.gutter {
        display: table-cell !important;
    }

    table {
        width: 100% !important;
    }

    .el-table__body {
        // 使表格兼容safari，不错位
        width: 100%;
        table-layout: fixed !important;
    }

    .el-dialog__body {
        padding-top: 10px!important;
        padding-bottom: 20px!important;
    }

    .zf-list {

        a {
            color: #60aeff
        }

        .el-table {
            margin-top: 10px;
        }

        .el-table th {
            padding: 5px 0;
        }

        .el-table td {
            padding: 0;
        }

        .tooltip-btn {
            padding: 3px 0;
            border: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            background: inherit;
            text-align: left;

            p {
                overflow: hidden;
            }
        }

        .tooltip-btn:focus,
        .tooltip-btn:hover {
            background: inherit;
            color: inherit;
        }

        .el-input__inner {
            height: 26px;
            margin: 4px 0;
        }

        .el-date-editor .el-range__icon {
            line-height: 26px;
        }

        .el-date-editor .el-range-separator {
            line-height: 26px;
        }

        .el-date-editor .el-range__close-icon {
            line-height: 26px;
        }

        .el-form--inline .el-form-item {
            margin: 0 5px;
        }

        .tooltip-p {
            padding: 10px;
            max-width: 200px;
        }

        .el-tooltip__popper {
            padding: 0;
        }

        .images {
            background: #fff!important;

            .tooltip-p {
                border: 1px solid #ccc!important;
                border-radius: 5px!important;

                a {
                    display: block;
                    padding-bottom: 5px
                }

                a:hover {
                    color: #60aeff;
                }
            }
        }
    }

    .el-upload {
        height: 100%;
    }

    .el-upload-list__item {
        transition: none !important;
    }

    .el-upload--picture-card {
        margin-bottom: 23px;
    }

    .el-table__body tr.current-row>td {
        background-color: #409EFF!important;
        color: #fff;
    }

</style>
